export default {
  api: {
    list: {
      method: "get",
      url: "/user/invoice/list"
    },
    amount: {
      method: "get",
      url: "/user/invoice/amount"
    },
    invoiceTitle: {
      method: "get",
      url: "/user/invoiceTitle/info"
    },
    applyInvoice: {
      method: "post",
      url: "/user/invoice/apply"
    },
    editInvoiceTitle: {
      method: "put",
      url: "/user/invoiceTitle/edit"
    }
  }
};
